var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilSilver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.16 15.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:.25px;}.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-3{fill:#afb1ae;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.16,
    y: -54.89,
    width: 14.99,
    height: 125,
    transform: "translate(62.05 77.26) rotate(-90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.16,1.1h123V14.1H8.16V1.1M7.16,.1V15.1h125V.1H7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.51,14.56c-4,.41-7.16-.89-7.85-3-.21-.65-.21-1.35,0-2V5.56c-.21-.65-.21-1.35,0-2C1.35,1.49,4.52,.2,8.51,.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.16,
    y1: 12.1,
    x2: 123.16,
    y2: 12.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.29,
    y1: 7.83,
    x2: 25.16,
    y2: 7.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.16,
    y1: 4.1,
    x2: 123.16,
    y2: 4.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.16 15.1 132.16 14.11 149.16 7.6 132.16 15.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "149.16 7.61 132.16 .11 132.16 1.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "146.06 8.97 146.06 6.36 149.16 7.61 146.06 8.97"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSilver);
export default __webpack_public_path__ + "static/media/Pencil_silver.c7d29edd67f59f3a2298b8ed6f079114.svg";
export { ForwardRef as ReactComponent };